import axios from 'axios';
import { AxiosConfig } from '@/config/config';

// eslint-disable-next-line new-cap
const Axios = new axios.create({
  baseURL: AxiosConfig.baseURL,
});

Axios.defaults.headers.common['X-Application-ID'] = AxiosConfig.applicationName;
Axios.defaults.headers.common.Accept = 'application/json';

const accessToken = localStorage.getItem('access_token');

if (accessToken) {
  Axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
}

export default Axios;
